import React, { useState, useEffect, useRef } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import keycode from 'keycode';
import AutosizeInput from 'react-input-autosize';
import {addTag, removeTag, updateTag} from "../../actions/post";
import {MAX_TAG_COUNT} from "../../constants/limits";

function Tag(props) {
  const { tag, onRemove, onUpdate } = props;
  const [updateMode, setUpdateMode] = useState(false);

  function handleUpdate(value) {
    onUpdate(tag, value);
    setUpdateMode(false);
  }

  if (updateMode) {
    return (
      <TagInput defaultValue={tag} onSave={handleUpdate} />
    );
  } else {
    return (
      <span key={tag} className="txt_tag">
      <span onClick={e => setUpdateMode(true)}>#{tag}</span>
      <button type="button" className="btn_delete" onClick={e => onRemove(tag)}>
        <span className="mce-ico ico_delete">삭제</span>
      </button>
    </span>
    );
  }
}


function TagInput({ defaultValue, onSave }) {
  const [value, setValue] = useState(defaultValue);
  let inputRef = null;
  useEffect(() => {
    if (inputRef) {
      inputRef.focus();
    }
  }, []);

  function handleKeyDown(e) {
    const code = keycode(e);
    if (code == ',' || code == 'enter' || code == 'tab') {
      e.preventDefault();
      onSave(value);
      setValue('');
    }
  }

  function handleBlur(e) {
    onSave(value);
    setValue('');
  }

  function handleChange(e) {
    const values = e.target.value.split(",");
    do {
      let value = values.shift();
      if (values.length === 0) {
        setValue(value);
      } else {
        onSave(value);
      }
    } while(values.length !== 0);
  }

  return (
    <span className="inp_tag">
      <span>#</span>
      <AutosizeInput
        inputRef={(input) => { inputRef = input }}
        type="text"
        title="태그"
        name="tagText"
        id="tagText"
        value={value}
        inputClassName="tf_g"
        placeholder="태그입력"
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        onChange={handleChange}
      />
    </span>
  );
}

export default function PostTags() {
  if (Config.postType !== 'post') {
    return null
  }

  const tags = useSelector(state => state.post.newPost.tags)
  const dispatch = useDispatch()

  function handleAddTag(tag) {
    dispatch(addTag(tag))
  }
  function handleRemoveTag(tag) {
    dispatch(removeTag(tag))
  }
  function handleUpdateTag(orgTag, tag) {
    dispatch(updateTag(orgTag, tag))
  }

  function handleAdd(tag) {
    const value = tag.replace(/,/g, '').trim();
    if (value !== '') {
      handleAddTag(value);
    }
  }

  function handleUpdate(orgTag, tag) {
    const value = tag.replace(/,/g, '').trim();
    if (value !== '') {
      handleUpdateTag(orgTag, value);
    }
  }

  return (
    <div className="editor_tag">
      {tags && tags.map(tag =>
        <Tag key={tag} tag={tag} onRemove={handleRemoveTag} onUpdate={handleUpdate} />
      )}

      {(!tags || tags.length < MAX_TAG_COUNT) &&
        <TagInput defaultValue='' onSave={handleAdd} />
      }
    </div>
  )
}
